import { Injectable } from '@angular/core';
import { ModeInterface } from './mode.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { ErrorModel } from '../../../../api';

@Injectable({
  providedIn: 'root'
})
export abstract class BaseMode implements ModeInterface{
  public title: string = null;
  public startUrl: string = null;

  protected loadingSubject: BehaviorSubject<boolean>;
  public loadingObservable: Observable<boolean>;

  protected repeatLoadingSubject: BehaviorSubject<boolean>;
  public repeatLoadingObservable: Observable<boolean>;

  protected errorSubject: BehaviorSubject<ErrorModel>;
  public errorObservable: Observable<ErrorModel>;

  protected constructor() {
    this.loadingSubject = new BehaviorSubject<boolean>(false);
    this.repeatLoadingSubject = new BehaviorSubject<boolean>(false);
    this.errorSubject = new BehaviorSubject<ErrorModel>( null);

    this.loadingObservable = this.loadingSubject.asObservable();
    this.repeatLoadingObservable = this.repeatLoadingSubject.asObservable();
    this.errorObservable = this.errorSubject.asObservable();
  }

  abstract submit (value);

  abstract repeat ();

}
